import { DbRef } from '@caresend/types';
import { getUnknownErrorMessage, errorSuffix, isNullish, nullishFilter } from '@caresend/utils';
import 'firebase/auth';
import { getOrderDataRequest } from '../../../database/firebaseConfig/cloudFunctions.js';
import '../../../database/firebaseConfig/init.js';
import { firebaseBind } from '../../../database/firebaseConfig/methods.js';
import '@sentry/vue';
import { toastErrorAndReport } from '../../../functions/toast/toast.js';
import '@fortawesome/fontawesome-svg-core';
import 'buefy';
import '../../../components/ui/Icon.vue.js';
import '../../../functions/configuration/icons.js';
import '../../../database/algoliaConfig/indices.js';
import 'mobile-device-detect';
import '../../../functions/tracking/index.js';
import '../../../router/helpers/initRouter.js';
import '@firebase/auth';
import 'browser-image-compression';
import 'firebase/storage';
import 'js-sha256';
import { initExtendedModule } from '../helpers.js';
import { setOrderDataInStore } from '../../set/order.js';

const ordersState = {
    isEndOfList: false,
    isLoading: false,
    keyData: null,
    orders: {},
};
const ordersMutations = {
    'orders/SET_ORDERS': (state, newOrders) => {
        state.orders = {
            ...state.orders,
            ...newOrders,
        };
    },
};
const ordersActions = {
    // TODO: Denormalized orders no longer used with this module. Take logic
    // from here as needed to fix/refactor ProcedureCancelationAlert.vue
    // 'orders/cancelDenormalizedOrderProcedure': async ({ commit, state }, payload) => {
    //   try {
    //     const { orderID, procedureID, reason, detailedReason, supplyCondition, userType } = payload;
    //     const order = state.denormalizedOrders[orderID];
    //     if (!order) throw Error('Order not found');
    //     // huh?
    //     const procedure = order.procedures?.[procedureID];
    //     if (!procedure) throw Error('Procedure not found');
    //     if (procedure.statusInfo.title === GenericStatusInfoTitle.CANCELED) {
    //       toastInfo('Order already canceled');
    //       return;
    //     }
    //     await setProceduresStatusRequest({
    //       procedureIDs: [procedureID],
    //       reason,
    //       detailedReason,
    //       supplyCondition,
    //       status: ProcedureStatus.CANCELED,
    //       userType,
    //     });
    //     commit('orders/SET_DENORMALIZED_ORDER_PROCEDURE_STATUS', {
    //       orderID: orderID,
    //       procedureID,
    //       status: ProcedureStatus.CANCELED,
    //     });
    //     toastSuccess('Order canceled successfully');
    //   } catch (error) {
    //     toastError(error);
    //   }
    // },
    async 'orders/fetchOrder'({ commit }, orderID) {
        try {
            const order = await getOrderDataRequest({
                orderID,
                getOrderDataInclusions: {
                    includeBookingsDataInOrderData: true,
                    includeDraftWaypointsDataInOrderData: true,
                    includeProceduresDataInBookingData: true,
                    includePatientDataInBookingData: true,
                },
            });
            if (!order)
                throw Error('Order not found.');
            setOrderDataInStore(commit, [order], this);
        }
        catch (error) {
            const message = getUnknownErrorMessage(error);
            toastErrorAndReport(`There was a problem loading your order: ${message} ${errorSuffix}`);
        }
    },
    'orders/bindOrder': async ({ commit, dispatch }, { orderID, skipUserFetches }) => {
        const userIDs = [];
        const path = `${DbRef.ORDERS}/${orderID}`;
        await firebaseBind(path, async (order) => {
            commit('orders/SET_ORDERS', {
                [order.id]: order,
            });
            if (order.prescriberID) {
                userIDs.push(order.prescriberID);
                if (!skipUserFetches)
                    await dispatch('users/fetchUser', order.prescriberID);
            }
        });
        return { userIDs };
    },
};
const ordersGetters = {
    'orders/getUsersOnOrder': (state, _getters, rootState) => (orderID) => {
        var _a;
        let users = [];
        const order = state.orders[orderID];
        if (isNullish(order) || isNullish(order.prescriberID))
            return [];
        const prescriber = rootState.users.users[order.prescriberID];
        if (prescriber)
            users.push(prescriber);
        const bookings = Object.values((_a = order === null || order === void 0 ? void 0 : order.bookings) !== null && _a !== void 0 ? _a : {}).map((booking) => rootState.bookings.bookings[booking.id]).filter(nullishFilter);
        const patients = bookings.map((booking) => rootState.users.users[booking.patientID]).filter(nullishFilter);
        users = [...users, ...patients];
        const procedures = bookings.map((booking) => {
            var _a;
            return Object.values((_a = booking.procedures) !== null && _a !== void 0 ? _a : {}).map((procedure) => rootState.procedures.procedures[procedure.id])
                .filter(nullishFilter);
        }).flat();
        const nurses = procedures.map((procedure) => procedure.nurseID ? rootState.users.users[procedure.nurseID] : undefined).filter(nullishFilter);
        users = [...users, ...nurses];
        return users;
    },
};
const ordersModule = {
    state: ordersState,
    mutations: ordersMutations,
    actions: ordersActions,
    getters: ordersGetters,
};
const initOrdersModule = (moduleExtensions) => initExtendedModule(ordersModule, moduleExtensions);

export { initOrdersModule };
